/**
 * Which tabs the Payroll page shows. `rates` is gated in the frontend on the same `payroll` as the
 * rate routes.
 *
 *   payroll  salary.view   routers/payroll.py
 *   oneoff   salary.view   routers/one_off_payslip.py
 *   rates    payroll       routers/payroll.py
 *   access   admin  routers/audit.py
 */
export type PayrollTab = 'payroll' | 'oneoff' | 'rates' | 'access'

const ORDER: { key: PayrollTab; ability: string }[] = [
  { key: 'payroll', ability: 'salary.view' },
  { key: 'oneoff', ability: 'salary.view' },
  { key: 'rates', ability: 'payroll' },
  { key: 'access', ability: 'admin' },
]

export function payrollTabs(holds: (ability: string) => boolean): PayrollTab[] {
  return ORDER.filter((tab) => holds(tab.ability)).map((tab) => tab.key)
}

export function openingTab(
  visible: PayrollTab[],
  requested: string | null | undefined,
): PayrollTab | undefined {
  return visible.find((tab) => tab === requested) ?? visible[0]
}
